import { Component, HostListener, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { HeaderComponent } from "../../header/header.component";
import { FooterComponent } from '../../footer/footer.component';
import { CommonModule } from '@angular/common';
import { WebService } from '../../services/web.service';
import { HttpClient, HttpClientModule, HttpHeaders } from '@angular/common/http';
  import { MetaTagService } from '../../meta-tag.service';
import { environment, GINConstants } from '../../../environments/environments';
import { IconsFreeToolsComponent } from '../../icons-free-tools/icons-free-tools.component';
@Component({
  selector: 'app-ai-business-report',
  standalone: true,
   imports: [HeaderComponent, CommonModule, HttpClientModule, FooterComponent,IconsFreeToolsComponent],

  templateUrl: './ai-business-report.component.html',
  styleUrl: './ai-business-report.component.css'
})
export class AiBusinessReportComponent {
  shouldShowButton: boolean = false;
  word_count = 0;
  char_count = 0;
  editortext = '';

  ngOnInit(): void {
    this.metaService.updateTags("Report Writer | Grammarin.com", "report-writer", "https://www.grammarin.com/report-writer");
  }
  constructor(private _webservice: WebService, @Inject(PLATFORM_ID) private platformID: Object, private httpClient: HttpClient,private metaService: MetaTagService) { }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (window.pageYOffset > 200) {
      this.shouldShowButton = true;
    } else {
      this.shouldShowButton = false;
    }
  }
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }


  public checkEmptyFields(form) {
    let emptyFields = [];

    if (form.form_target === '') {
      emptyFields.push('form_target');
    }
    if (form.form_detailed === '') {
      emptyFields.push('form_detailed');
    }
    if (form.form_findings.trim() === '') {
      emptyFields.push('form_findings');
    }
    if (form.form_recommendations.trim() === '') {
      emptyFields.push('form_recommendations');
    }
    return emptyFields;
  }
  public color: string = 'black';
  public esubText: string = '';
  public esubText2: string = '';
  eFsubText2: any;
  public loaderAlert: boolean = false;
  output: any;
  original: any;
  corrected: any;
  public eFsubIF: boolean = false;
  output_display = false;

  public form_target: any;
  public form_detailed: any;
  public form_findings: any;
  public form_recommendations: any;

  public eFormSubmission(event: any) {


    this.output_display = false;
    event.preventDefault();
    this.eFsubIF = false
    this.form_target = $('#form_target').val();
    this.form_detailed = $('#form_detailed').val();
    this.form_findings = $('#form_findings').val();
    this.form_recommendations = $('#form_recommendations').val();
    let form = {
      form_target: this.form_target,
      form_detailed: this.form_detailed,
      form_findings: this.form_findings,
      form_recommendations: this.form_recommendations
    };
    let emptyFields = this.checkEmptyFields(form);
    if (emptyFields.length > 0) {
      this.color = '#721c24';
      this.eFsubText2 = 'Please provide the required fields';
      emptyFields.forEach(function (field) {
        $('#' + field).css("border-color", "red");
      });
      this.eFsubIF = true
      $("#eFsubText2").show();
      setTimeout(function () {
        $("#eFsubText2").hide();
        emptyFields.forEach(function (field) {
          $('#' + field).css("border-color", "#08BA9C");
        });
        this.eFsubIF = false
      }, 3000);
    }
    else {
      this.loaderAlert = true;
      const headers = new HttpHeaders({
        'Authorization': environment.AuthorizationGIN,
      });
      this.httpClient.post(environment.API_URL+'/api/aiBusinessReport', { 'target': this.form_target, 'detailed': this.form_detailed, 'findings': this.form_findings, 'recommendations': this.form_recommendations }, { headers }).subscribe(
        (response) => {

          this.output_display = true;
          this.output = response['output']
          // setInterval(() => {  this.output = response['output'].replace(/\n/g, '<br>'); $('#outputs').html(this.output); }, 1000);
          this.loaderAlert = false;
          $('#form_target').css("border-color", "#e7e7ec").css("background-color", "white");;;
          $('#form_detailed').css("border-color", "#e7e7ec").css("background-color", "white");;;
          $('#form_findings').css("border-color", "#e7e7ec").css("background-color", "white");;;
          $('#form_recommendations').css("border-color", "#e7e7ec").css("background-color", "white");;;
        },
        (error) => {
          // console.error(error);
          this.output_display = true;
          this.loaderAlert = false;
          this.output = "Something went wrong. Please try again later."
          $('#form_target').val('').css("border-color", "#e7e7ec");
          $('#form_detailed').val('').css("border-color", "#e7e7ec");
          $('#form_findings').val('').css("border-color", "#e7e7ec");
          $('#form_recommendations').val('').css("border-color", "#e7e7ec");
        }
      );

    }
  }

  public copiedtext: boolean = false;
  public copried_txt: string = '';
  // copyToClipboard(): void {
  //   const textarea = document.createElement('textarea'); 
  //   textarea.value = this.output;
  //   document.body.appendChild(textarea); 
  //   textarea.select(); 

   
  //   try {
  //     const successful = document.execCommand('copy'); 
  //     if (successful) {
  //       this.copiedtext = true;
  //       this.copried_txt = 'copied'; 
  //       $("#copytextId").hide(); 
  //       $("#copried_txt").show(); 

        
  //       setTimeout(() => {
  //         $("#copried_txt").hide();
  //         $("#copytextId").show();
  //         this.copiedtext = false; 
  //       }, 2000);
  //     } else {
  //       // console.error('Failed to copy text');
  //       this.copiedtext = false;
  //     }
  //   } catch (err) {
  //     // console.error('Error copying text: ', err); 
  //     this.copiedtext = false; 
  //   } finally {
  //     document.body.removeChild(textarea); 
  //   }
  // }
  copyToClipboard() {
    if (this.output) {
   
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = this.output;
  
   
      const selection = window.getSelection();
      const range = document.createRange();
      range.selectNodeContents(tempDiv);
      
 
      selection.removeAllRanges();
      selection.addRange(range);
  
    
      navigator.clipboard.write([
        new ClipboardItem({
          'text/html': new Blob([tempDiv.innerHTML], { type: 'text/html' }),
          'text/plain': new Blob([tempDiv.innerText], { type: 'text/plain' })
        })
      ]).then(() => {
        this.copiedtext = true;
        setTimeout(() => {
          this.copiedtext = false;
        }, 2000);
      }).catch(err => console.error('Failed to copy:', err));
  

      selection.removeAllRanges();
    }
  }
  reFreshWindow(){
    window.location.reload();
  }
  getContent(event: KeyboardEvent) {
    const target = document.getElementById("form_detailed") as HTMLTextAreaElement;
    if (!target) return; 

    this.editortext = target.value.trim(); 
    this.char_count = this.editortext.length;
    this.word_count = this.editortext.split(/\s+/).filter(word => word !== "").length; 

    const words_field = ["form_detailed"];

    if (this.word_count > 100) {
      this.color = "#721c24";
      this.eFsubText2 = "Please shorten your text";

      words_field.forEach((field) => {
        $("#" + field).css("border-color", "red");
      });

      this.eFsubIF = true;
      $("#eFsubText2").text(this.eFsubText2).show();

      setTimeout(() => {
        $("#eFsubText2").hide();
        words_field.forEach((field) => {
          $("#" + field).css("border-color", "");
        });
        this.eFsubIF = false;
      }, 3000);
    } else {
      $("#eFsubText2").hide();
      words_field.forEach((field) => {
        $("#" + field).css("border-color", "");
      });
      this.eFsubIF = false;
    }

  }
}
